import { combineReducers } from '@ngrx/store';

import { refreshTimerReducer as refreshTimer } from '@shared/refresh-search/store/reducers/refresh-timer.reducer';

export const refreshSearchRootReducer = combineReducers({
  refreshTimer,
});
